@if (parentForm) {
  <div class="flex flex-col gap-y-20" [formGroup]="parentForm">
    <label class="font-bold" for="notes">Please provide additional trade instructions here as needed</label>
    <textarea class="textarea min-h-120" rows="6" placeholder="Enter notes here..." formControlName="notes"></textarea>
  </div>
}